module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h1', {
    staticClass: "u"
  }, [_vm._v("\n    Редактировать скидку\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'discount-details',
        params: {
          id: _vm.discount.id
        }
      }
    }
  }, [_vm._v("← Назад к Деталям скидки")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.discount.id) ? _c('a', {
    staticClass: "red",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteDiscount.apply(null, arguments)
      }
    }
  }, [_vm._v("удалить скидку")]) : _vm._e()]), _vm._v(" "), _c('discount-edit-form', {
    attrs: {
      "discount": _vm.discount
    },
    on: {
      "after": _vm.handleAfter
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-456a7ed7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/discount/DiscountEdit.vue
// module id = 632
// module chunks = 0